<template>
  <ul class="timeline">
    <time-line-item v-for="item in items" :key="item" :item="item"/>
  </ul>
</template>

<script>
  import TimeLineItem from '@/components/template/timeLine/Item'

  export default {
    props: {
      items: {
        type: Array,
        required: true
      }
    },
    components: {
      TimeLineItem
    }
  }
</script>

<style lang="sass">
  .timeline
    list-style: none
    padding: 20px 0 20px
    position: relative

    &:before
      background-color: #7872ff
      bottom: 0
      content: " "
      left: 50px
      margin-left: -1.5px
      position: absolute
      top: 0
      width: 3px
</style>



// WEBPACK FOOTER //
// Template.vue?52ec0cf3